import React from 'react';
import { Box, Typography } from '@curves/ui-base';

const PointsSummaryBox = ({ currentPoints, expiryDate }) => {
    return (
        <Box className="points-summary-box">
            <Box className="points-row">
                <Box className="points-item">
                    <Typography variant="caption" className="points-label">
                        目前點數
                    </Typography>
                    <Typography variant="h2" className="points-value">
                        {currentPoints ?? '-'}
                    </Typography>
                </Box>
            </Box>
            {expiryDate && (
                <Box className="points-expiry-row">
                    <Typography className="points-expiry-text">⚠ 點數將於 {expiryDate} 失效</Typography>
                </Box>
            )}
        </Box>
    );
};

export default PointsSummaryBox;
